import React, { Component } from "react";
import {
    Table
} from "reactstrap";

import Registry from "../../../Utils/Registry";
import Helpers from "../../../Utils/Helpers";

import OperationsOrdersTableLine from "../Orders/Table/Line";
import OperationsOrdersCancelModal from "./CancelModal";
import {NotificationManager} from "react-notifications";


class OperationsOrdersTable extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.setOrderCanceled = this.setOrderCanceled.bind(this);
        this.cancelCancelation = this.cancelCancelation.bind(this);
        this.onCancelAsked = this.onCancelAsked.bind(this);

        this.state = {
            information: false,
            cancelOrder: null,
            orders: []
        };
    }

    setOrderCanceled(order){
        this.setState({cancelOrder: order});
    }

    cancelCancelation(){
        this.setState({cancelOrder: null});
    }

    onCancelAsked(){
        this.setState({cancelOrder: null}, () => {
            this.props.refreshAfterDelete();
            NotificationManager.info("Votre demande d'annulation à bien été transmise, elle sera traitée dans les plus brefs delais");
        });
    }

    render(){
        return (
            <div>
                <div className="ty-block">

                    {
                        this.state.cancelOrder ?
                            <OperationsOrdersCancelModal
                                order={this.state.cancelOrder}
                                isOpen={true}
                                onRefuse={this.cancelCancelation}
                                onRequestMade={this.onCancelAsked}
                            />
                            :
                            ""
                    }

                    <Table responsive striped hover className="pointer spacing-table marg-b-0 f-12">
                        <thead>
                            <tr className="ty-table-header">
                                <th className="" style={{minWidth: "5rem"}}>N&deg;</th>
                                <th className="wp-10">Date</th>
                                <th className="_w-60">Heure</th>
                                <th className="center-important">Nb v&eacute;hi.</th>
                                <th className="w-15">Qt&eacute;</th>
                                <th className="center-important">Pay&eacute;</th>
                                <th className="_w-50"> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.orders.map((order, i) => {
                                    let actions = [];

                                    if(this.props.orderStatus === "coming" && !order.cancel_request_datetime){
                                        actions = [
                                            {label: "Annuler", onclick: () => { this.setOrderCanceled(order); }}
                                        ];
                                    }

                                    return (
                                        <OperationsOrdersTableLine
                                            key={i}
                                            order={order}
                                            actions={actions}
                                            onLineClicked={order => { Helpers.goTo("/commande/" + order.shorten); }}
                                        />
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}

OperationsOrdersTable.defaultProps = {
    orders: [],
    orderStatus: "done",
    onRemoveOrder: () => {},
    onNotify: (message, type="success", timeout=5000) => {},
};

export default OperationsOrdersTable;



// WEBPACK FOOTER //
// ./src/components/Operations/Orders/OrdersTable.js